export const DETAILS_PANEL_TEST_ID = 'DetailsPanel';
export const TRACKING_NUMBER_TEST_ID = 'TrackingNumber';
export const ADDRESS_TEST_ID = 'Address';
export const ADDRESS_LINES_TEST_ID = 'AddressLines';
export const REDIRECT_INFO_TEST_ID = 'RedirectInfo';
export const REDIRECT_LINK_ADDRESS_TEST_ID = 'RedirectLink';
export const REDIRECT_INELIGIBLE = 'RedirectIneligible';
export const REDIRECT_FAILED = 'RedirectFailed';
export const RECIPIENT_NAME_TEST_ID = 'RecipientName';
export const SENDER_INSTRUCTIONS_TEST_ID = 'SenderLine';
export const RECIPIENT_INSTRUCTIONS_TEST_ID = 'RecipientLine';
export const SAFE_DROP_INSTRUCTIONS_TEST_ID = 'SafeDropLinkLine';
export const SERVICE_FEATURES_TEST_ID = 'ServiceFeatures';
export const MEASUREMENTS_TEST_ID = 'Measurements';
export const DIMENSION_WARNING_TEST_ID = 'DimensionWarning';
